import React from 'react'

export default function NotFound() {
  return <>
  
   
    <div className="container">
      <div className="row ">
       
        <div className="col-md-6 d-flex justify-content-center align-content-center mx-auto ">
          <div className="  my-3 ">
         
            <div className="m-auto my-3    w-50  " >
              <img src={require('../../images/notFound.png')} alt="hi" className='w-100' />
            </div>
            
                <div className=" ale-notFound rounded rounded-start-pill  rounded-end-pill text-center my-5 py-3">
          <h4 > Error 404  not found !</h4>


             </div>
          </div>
        </div>
      </div>
</div>

  
  
  
  
  
  
  
  
  </>
}
